async function loadAlert(alerts: string){
    //moman query est une variable JS que j'ai créé et qui renvoie l'url de base du site web
    // @ts-ignore
    let url = moman_global.base_url + '/wp-json/moman/v1/alert';

    if (alerts !== '') {
        url += '?exclude=' + alerts;
    }

    let response = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            // @ts-ignore
            'X-WP-Nonce': moman_global.nonce
        },
    });
    return await response.json();
}

async function newAlert(alerts: any){
    //moman query est une variable JS que j'ai créé et qui renvoie l'url de base du site web
    // @ts-ignore
    const url = moman_global.base_url + '/wp-json/moman/v1/alert/new';

    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            alertId: alerts
        }),
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Accept': 'application/json',
            // @ts-ignore
            'X-WP-Nonce': moman_global.nonce
        },
    });
    return await response.json();
}

/**
 * @description Création de la popin
 */
function popin(data: any) {
    let popin = '';

    if (
      typeof data.icon !== 'undefined' &&
      data.icon
    ) {
        popin += `<span aria-hidden="true" class="popin__img" style="background-image: url('${data.icon}');"></span>`;
    }

    popin += `<button class="popin__close" aria-describedby="alert-${data.id}"  data-id="${data.id}"><span class="sr-only">fermer l'alerte</span><i data-icon="cross"></i></button>`;
    popin += `<div class="popin__content" role="document">
                <h2 class="popin__title" data-dot="2" id="alert-${data.id}">${
      data.title
    }</h2>
              <div class="popin__paragraph">
                ${data.text}
              </div>`;

    if (typeof data.url !== 'undefined' && data.url) {
        popin += `<a class="popin__link" href="${
          data.url.url
        }"${data.url.target ? ' target="_blank"' : ''}><i data-icon="arrow"></i><span class="popin__link__text">${
          data.url.title
        }</span></a>`;
    }

    return popin;
};

function popinPosition() {
    const contenairAlert = document.querySelector('.alert') as HTMLElement || null;
    const header = document.querySelector('header') as HTMLElement || null;
    const wpBar = document.querySelector('#wpadminbar') as HTMLElement || null;

    if(wpBar) {
        contenairAlert.style.top = `${parseInt(window.getComputedStyle(header, null).getPropertyValue("height")) + parseInt(window.getComputedStyle(wpBar, null).getPropertyValue("height")) + 34}px`;
    } else {
        contenairAlert.style.top = `${parseInt(window.getComputedStyle(header, null).getPropertyValue("height")) + 34}px`;

    }
}

const A11Y = () => {
    const alertContent = document.querySelector('[data-popin-content]');

    if (alertContent) {
        const focusable = alertContent.querySelectorAll(
            'button, [href], [tabindex]:not([tabindex="-1"]'
        );
        const firstFocusableElement= focusable[0] as HTMLElement ; // get first element to be focused inside modal
        const lastFocusableElement = focusable[focusable.length - 1] as HTMLElement; // get last element to be focused inside modal

        alertContent.addEventListener('keydown', function (e: KeyboardEvent) {
            if (e.key === 'Escape') {
                document.querySelector("[data-popin-content]").classList.add('popin__close__content');
                setTimeout(() => {
                    document.querySelector('[data-popin-content]').innerHTML = '';
                }, 1500);
                //document.querySelectorAll('.bypass-links li a')[0].focus();
            } else if (e.shiftKey) {
                // if shift key pressed for shift + tab combination
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus(); // add focus for the last focusable element
                    e.preventDefault();
                }
            } else {
                // if tab key is pressed
                if (e.key !== 'Enter') {
                    if (document.activeElement === lastFocusableElement) {
                        // if focused has reached to last focusable element then focus first focusable element after pressing tab
                        firstFocusableElement.focus(); // add focus for the first focusable element
                        e.preventDefault();
                    }
                }
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    let alerts = (JSON.parse(localStorage.getItem("alerts"))) ? JSON.parse(localStorage.getItem("alerts")) : [];
    let join = '';

    if (alerts) {
        join = alerts.join('-');
    }

    loadAlert(join).then((data: any) => {
        //ici tu envoies les différentes données dans une div vide par exemple que tu as créé auparavant.
        const contenairAlert = document.querySelector('.alert') as HTMLElement || null;
        if (data.id) {
            contenairAlert.insertAdjacentHTML('afterbegin', popin(data));

            const popinClose = document.querySelector('.popin__close') as HTMLElement || null;

            popinClose.addEventListener('click', () => {
                let id = popinClose.getAttribute('data-id');
                addAlert(id);
                alerts.push(id);
                newAlert(alerts);
                document.querySelector("[data-popin-content]").classList.add('popin__close__content');
                setTimeout(() => {
                    document.querySelector('[data-popin-content]').innerHTML = '';
                }, 1500);
            });

            popinPosition();
            popinClose.focus();
            A11Y();
            contenairAlert.setAttribute('aria-labelledby', `alert-${data.id}`);
        } else {
            if(contenairAlert !== null) {
                contenairAlert.style.display = "none";
            }
        }
    });
});

function addAlert(id: any) {
    let existingEntries = JSON.parse(localStorage.getItem("alerts"));
    if(existingEntries == null) existingEntries = [];

    if (!existingEntries.includes(id)) {
        existingEntries.push(id);
    }

    localStorage.setItem("alerts", JSON.stringify(existingEntries));
}